export default __webpack_public_path__ + "static/position-risk-manager-fcf26ebed89200ad05acd6b3a2bfb0e7.png";